export function invoicesToDispatch (state) {
    var data = state.tableDespatch.data.filter((value) => {
        return value.pack_off;
    })
    return data
}

export function countDocumentsProductsLot (state) {
    return state.tableDocumentsProductsLot.data.length;
}


// WEBPACK FOOTER //
// ./src/modules/despatch/getters.js